export const disableBackToOriginalImage = element =>
  element.picWhileCroppingProperties.width === element.width &&
  element.picWhileCroppingProperties.height === element.height &&
  element.picWhileCroppingProperties.y === element.y &&
  element.picWhileCroppingProperties.x === element.x;
